exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.solicitudes[data-v-41d750a2] {\n  margin-top: 30px;\n}\n", ""]);

// exports
